module.exports = __webpack_public_path__ + "img/landing-ebay.2da4c85b.svg";